<div class="popupGeneric" [class.fullScreeMode]="isfullScreeMode">
    <div class="popupGeneric-wrapper" [class.fullHeight]="fullHeight" [class]="'popupGeneric-wrapper_'+size+'Size'">

        @if (!!title) {
        <div class="popupGeneric-wrapper-header">

            <berry-typo color="primary" [weight]="weight" class="hiddenXsMode headerTitle">{{title|translate}} {{subTitle|translate}} </berry-typo>
            <div>

                <ng-container *ngIf="!!buttonHeader">
                    <berry-icon [size]="20" [color]="'brand'" [name]="buttonHeader" (click)="onButtonHeaderClick()" [title]="buttonHeaderTitle | translate"></berry-icon>
                </ng-container>
                <ng-container *ngIf="showFullscreenButton">
                    <berry-icon [size]="20" [color]="'secondary'"
                                [name]="!isfullScreeMode ? 'open_in_full' : 'close_fullscreen'" (click)="fullScreeToggle()"
                                class="hiddenXsMode"></berry-icon>
                </ng-container>
                <button class="close-button" (click)="dismiss()">
                    <berry-icon [size]="20" [color]="'muted'" [name]="'close'"></berry-icon>
                </button>

            </div>
            <berry-typo class="headerTitleXsMode" [weight]="700" [name]="'h5'">{{title|translate}} {{subTitle|translate}} </berry-typo>

        </div>
        }
        <div class="popupGeneric-wrapper-container">
            <ng-container #template></ng-container>

        </div>
        @if (isBusy) {
        <div class="overlay-loader">
            <berry-loader />
        </div>
        }

        @if (viewFooter) {
        <div class="popupGeneric-wrapper-footer" [class.flex-column-reverse]="size == 'xs'">
            
            @if (size!=='xs') {
                <div class="flex-1"></div>
            }

            @for(btn of otherButtons;track $index){
            <berry-button [style]="btn.style || 'filled'" [style.order]="btn.order || 'unset'" [data-automation-id]="btn.automationId" [disabled]="isBusy || btn.disabled" [type]="btn.type" [label]="btn.label | translate"
                          (click)="btn.event()"  [leftIcon]="btn.leftIcon" size="medium">
            </berry-button>
            }

            
            <ng-container *ngIf="!!closeButtonText">
                <berry-button [data-automation-id]="'popup-dismiss'" [type]="closeButtonColor || 'secondary'" [disabled]="isBusy" [label]="closeButtonText|translate "
                              (click)="dismiss()" size="medium" type='secondary'>
                </berry-button>
            </ng-container>
            <ng-container *ngIf="!!submitButtonText">
                <berry-button [data-automation-id]="'popup-submit'" [disabled]="isBusy || disableSubmit" [type]="submitButtonColor || 'primary'" [label]="submitButtonText|translate"
                              (click)="onSubmit()" size="medium">
                </berry-button>
            </ng-container>


        </div>
        }

    </div>
</div>
